// extracted by mini-css-extract-plugin
module.exports = {"albums":"ArtistAlbums_albums__1G3_a"};